import { memo } from "react";
import { Typography, Box, Grid, Skeleton } from "@mui/material";
import IconAI from "../../../assets/Images/IconAI.png";
import Shadow from "../../../assets/Images/Shadow.png";
import Chart from "../../../assets/Images/chart.png";
import OverLay from "../../../assets/Images/Overlay.png";
import useStyles from "./useStyles";

const LoadingFallBack = () => {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.around}>
        <img src={IconAI} alt="" width={22} height={22} />
        <div style={{ width: "100%" }}>
          <div>
            <Typography variant="body2" sx={{ fontWeight: "700" }}>
              Đang tìm kiếm nâng cao
            </Typography>
          </div>
          <div>
            <Typography variant="caption" sx={{ color: "#444654" }}>
              So sánh các tuỳ chọn phù hợp nhất với yêu cầu của bạn..
            </Typography>
          </div>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: 10,
              borderRadius: 999,
              bgcolor: "#e5e7eb",
              overflow: "hidden",
              marginTop: "6px",

              "&::before": {
                content: '""',
                position: "absolute",
                width: "25%",
                height: "100%",
                borderRadius: 999,
                background:
                  "linear-gradient(90deg, #2E4FCE00, #2E4FCE66, #2E4FCE00)",
                animation: "loading 1.2s ease-in-out infinite",
              },

              "@keyframes loading": {
                "0%": {
                  transform: "translateX(-100%)",
                },
                "100%": {
                  transform: "translateX(500%)",
                },
              },
            }}
          />
        </div>
      </div>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          marginTop: "25px",
          height: 280,
          borderRadius: "24px",
          background: `
      radial-gradient(
        circle at 30% 50%,
        rgba(129, 55, 255, 0.35) 0%,
        transparent 45%
      ),
      linear-gradient(
        135deg,
        #7B94FF 0%,
        #5D7BFA 55%,
        #4B6AE8 100%
      )
    `,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 20,
            left: 20,
            background: "rgba(129, 55, 255, 0.6)",
            width: "56px",
            height: "56px",
            display: "flex",
            alignItems: "center",
            justifyItems: "center",
            justifyContent: "center",
            borderRadius: "12px",
          }}
        >
          <img
            src={Chart}
            alt=""
            width={32}
            height={32}
            style={{ padding: 2 }}
          />
        </div>
        <img
          style={{ position: "absolute", top: "35%", left: "46.5%" }}
          src={Shadow}
          alt=""
          width={80}
          height={80}
        />
        <Typography
          variant="body1"
          sx={{ position: "absolute", left: "42%", top: "75%", color: "white" }}
        >
          Đang phân tích và tính toán
        </Typography>
        <Box
          sx={{
            position: "absolute",
            bottom: 6,
            left: "48%",
            display: "flex",
            gap: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                bgcolor: "white",
                animation: "bounce 1.2s infinite ease-in-out",
                animationDelay: `${index * 0.2}s`,

                "@keyframes bounce": {
                  "0%, 80%, 100%": {
                    transform: "translateY(0)",
                    opacity: 0.4,
                  },
                  "40%": {
                    transform: "translateY(-8px)",
                    opacity: 1,
                  },
                },
              }}
            />
          ))}
        </Box>
      </Box>
      <Box sx={{ mt: 3 }} className={classes.around3}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <img src={OverLay} alt="" width={45} height={35} />
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            Khoảng giá cấp đơn
          </Typography>
        </Box>
        <Grid container spacing={3} mt={2}>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={20} />
          </Grid>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={20} />
          </Grid>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={60} />
          </Grid>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default memo(LoadingFallBack);
